<p-orderList [value]="enderecos" 
            i18n-header             
            header="Endereços" 
            filterBy="enderecoCompleto"
            filter="filter" 
            i18n-filterPlaceholder
            filterPlaceholder="Buscar endereço...">
  <ng-template let-endereco pTemplate="item">
      <div class="ui-helper-clearfix" (click)=selecionarEndereco(endereco)>
          <img src="assets/images/home.png" style="display:inline-block;margin:2px 0 2px 2px" width="48" />
          <div style="font-size:14px;float:right;margin:15px 5px 0 0" >
            {{endereco.enderecoCompleto}}
          </div>
      </div>
  </ng-template>
</p-orderList>
